import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { DialogOfficialsDirectoryComponent } from './dialog-officials-directory/dialog-officials-directory.component';
import { OpAttorneyService } from 'src/app/services/opattorney.service';
import { DocumentModel } from 'src/app/models/document.model';
import { OpAttorneyModel } from 'src/app/models/opattorney.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import { DialogService } from 'src/app/services/dialog.service';

declare const TXTextControl: any;

interface ClientAddress {
  label: string;
  address: string;
}

@Component({
  selector: 'tx-section-addresses',
  templateUrl: './section-addresses.component.html',
  styleUrls: ['./section-addresses.component.scss'],
})
export class SectionAddressesComponent implements OnInit, OnDestroy {
  @ViewChild('attorneyMenu') attorneyMenu!: NgbDropdown;
  @ViewChild('clientsMenu') clientsMenu!: NgbDropdown;
  public disableClientsButton = true;
  public attorneys: OpAttorneyModel[] = [];
  public clientAddressMenuItems$ = new BehaviorSubject<ClientAddress[]>([]);
  private subscriptions = new Subscription();
  private document!: DocumentModel | null;

  constructor(
    public attorneyService: OpAttorneyService,
    private documentService: DocumentService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.initializeClientsMenu();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initializeClientsMenu() {
    this.subscriptions.add(
      this.documentService.document$.subscribe((document) => {
        this.document = document;
        this.disableClientsButton = !Boolean(document);
        if (document) {
          // ToDo: replace addr1 and addr2 with full address field once available
          const address1 = document.addr1
            ? {
                label: document.addr1Type ?? 'Address 1',
                address: document.addr1,
              }
            : ({} as ClientAddress);
          const address2 = document.addr2
            ? {
                label: document.addr2Type ?? 'Address 2',
                address: document.addr2,
              }
            : ({} as ClientAddress);
          const billingAddress = document.billingAddress
            ? {
                label: 'Billing Address',
                address: document.billingAddress,
              }
            : ({} as ClientAddress);

          this.clientAddressMenuItems$.next([{ ...address1 }, { ...address2 }, { ...billingAddress }]);
        }
      })
    );
  }

  openOfficialsDirectory() {
    this.dialogService
      .openCustomDialog('officialsDirectory', DialogOfficialsDirectoryComponent, {
        size: 'lg',
        centered: true,
      })
      .result.then((address) => {
        TXTextControl.beginUndoAction('InsertPleading', () => {
          TXTextControl.selection.setText(address, () => {
            TXTextControl.selection.setText('\n', () => {
              TXTextControl.endUndoAction();
              TXTextControl.focus();
            });
          });
        });
      });
  }

  toggleAttorneyMenu() {
    this.attorneyMenu?.toggle();
    if (this.attorneyMenu.isOpen()) {
      const caseID = this.document?.casID;
      this.attorneyService.fetchAll(caseID || '');
    }
    return false;
  }

  toggleClientsMenu() {
    this.clientsMenu?.toggle();
    return false;
  }

  onSelectAttorney(item: OpAttorneyModel) {
    this.attorneyMenu.close();
    TXTextControl.beginUndoAction('InsertOpposingAttorneyText', () => {
      TXTextControl.selection.setText(item.address, () => {
        TXTextControl.selection.setText('\n', () => {
          TXTextControl.endUndoAction();
          TXTextControl.focus();
        });
      });
    });
  }

  onSelectClient(item: ClientAddress) {
    this.clientsMenu.close();
    TXTextControl.beginUndoAction('InsertClientAddress', () => {
      TXTextControl.selection.setText(item.address, () => {
        TXTextControl.selection.setText('\n', () => {
          TXTextControl.endUndoAction();
          TXTextControl.focus();
        });
      });
    });
  }
}
